export const pagetitle = {
    DFS: '名貴獨家旅遊獎賞',
    Hotel: '酒店權益',
    Enquiry: '在綫預訂',
    Detail: '權益詳情',
    Search: '搜索',
    Login: '登錄'
}

export const home = {
    recommend: '推薦服務',
    benefits: '禮遇及福利',
    benefitsInfo: '探索我們的禮賓服務、旅行和生活方式體驗、專享權益以及禮賓計劃詳情',
    contact: '瞭解更多',
    hotline: '熱線',
    livechat: '在綫客服',
    more: '更多',
    welcometitle: '歡迎使用迪斐世尊享會24小時精緻生活禮賓服務',
    welcomedetail: '在此，迪斐世尊享會高級會員可盡享非凡的個性化服務，包括酒店預訂、餐廳推薦以及更多奢尚驚喜。',
    welcomenotice: '本服務是由我們的合作伙伴Aspire提供。所收集的相關信息僅限用於提供私人禮賓服務、提升服務品質以及內部培訓。',
    selectnumber: '請選擇電話號碼',
    selectnumbertips:'我們的客服服務團隊可以根據您選擇的地點，為您提供英語、普通話、粵語或日語服務。',
    selectnumbernotice:'*根據您所選地點的服務供應商，可能會收取本地/海外費用。',
    booking: '接送機預訂方法',
    click: '點擊查看'
}

export const service = {
    title: '迪斐世尊享會專享預訂福利',
    list1: '解鎖大使級會員專享權益',
    list2: '免費升級酒店房型及早餐',
    list3: '可享提前入住及延遲退房服務，度假村及水療服務',
    tips: '具體以酒店說明為準',
    more: '展開',
    less: '收起'
}

export const toolbar = {
    hotel: '酒店',
    dinning: '餐飲',
    travel: '旅行',
    entertainment: '娛樂',
    club: '私人會所',
    education: '教育',
    golf: '高爾夫球',
    business: '商務',
    reservation: '酒店預訂'
}

export const category = {
    hotel: '酒店',
    dinning: '餐飲',
    travel: '幾場或旅行服務',
    entertainment: '娛樂',
    club: '私人會所',
    education: '教育',
    golf: '高爾夫球',
    business: '商務',
}

export const info = {
    hotel: '通過我們的禮賓服務安排下一趟旅程，入住奢華酒店可享免費房型升級、免費早餐以及其他尊貴VIP服務。',
    dinning: '我們的禮賓團隊將為您提供熱門餐廳預訂服務，以便您體驗非凡環球美饌及美酒。',
    travel: '旅行',
    entertainment: '娛樂',
    club: '私人會所',
    education: '教育',
    golf: '高爾夫',
    business: '商務',
    loginTitle: '獨家旅遊獎賞',
    loginSubtitle: '請登錄後查閱權益及商戶詳情',
    hometitle: '<span>生活</span>獨家旅遊獎賞<span>體驗令人驚艷的旅遊勝地，在記憶中留下美麗的印記，得到心靈上的滿足，改變您的視野。</span>',
    homesubtitle: '<span class="color-yellow">銀聯鑽石Prestige持卡人專享：</span>銀聯鑽石Prestige信用卡持卡人於2025年1月1日至2025年12月31日內（含首尾兩日）累積合資格簽賬滿指定金額，即可參與並換領專屬旅遊獎賞。兌換截至2025年12月31日。使用截至2026年3月31日。<br/>每次換領申請僅限一位持卡人。每月換領名額有限。換領於每月名額有限，先到先得，額滿即止。每筆簽賬僅限一次兌換，不可重複用於其他優惠活動。'
}

export const city = {
    hotcity:'熱門城市',
    shanghai: '上海',
    osaka: '大阪',
    singapore: '新加坡',
    hiangmai: '清邁',
    paris: '巴黎',
    london: '倫敦',
    newyork: '紐約',
    sydney: '悉尼'
}

export const hotel = {
    title: '酒店預訂',
    more: '檢視更多',
    location: '地点',
    searchcity: '搜索城市',
    pickdate: '選擇日期',
    travelernumber: '入住人數',
    childnumber: '兒童人數',
    nightSin: '晚',
    nightPlu: '晚',
    room: '房間',
    roomSin: '間',
    roomPlu: '間',
    adults: '成人人數',
    adultSin: '成人',
    adultPlu: '成人',
    children: '兒童人數',
    childSin: '兒童',
    childPlu: '兒童',
    travelerSin: '位',
    travelerPlu: '位',
    age: '0-16歲',
    group: '酒店品牌',
    all: '全部',
    hotcity: '熱門目的地',
    brandfilter: '品牌',
    pricefilter: '價格',
    privilege: 'VIP 特權',
    discount: '已享折扣',
    from: '最低',
    full: '不適用',
    empty: '即將推出',
    noroomdata: '您選擇的日期當前暫無房型',
    selectroom:'選擇房型',
    roomtype: '房型',
    facility: '設施及服務',
    policy: '取消政策',
    noncancel: '不可取消',
    deadline: '前可取消，超過最晚取消時間取消，酒店將有權扣除1晚的房費',
    searchtip: '如果未能找到您想要的酒店，請聯繫客服'
}

export const buttonTxt = {
    done: '確認',
    cancel: '取消',
    search: '搜索',
    selectroom: '請選擇房型',
    bookroom: '立即預訂',
    confirmbook: '確認',
    myorder: '查看訂單',
    gohome: '返回首頁',
    reserve: '立即預約',
    enquire: '預約下單',
    submitEnquire: '預約下單',
    accept: '接受',
    change:'返回修改',
    cancelOrder: '取消訂單',
    confirm: '確認',
    notcancel: '暫不取消',
    verify: '驗證卡號',
    upload: '點擊上傳'
}

export const toast = {
    title: '提示',
    pickerdate: '至少一晚',
    errorEmail: '郵箱格式錯誤',
    errorName: '英文名或拼音',
    unLogin: '用戶未登錄',
    nologin:'缺少用戶信息，請重新登錄',
    cancelTitle: '確認取消訂單?',
    cancelTip: '請確認是否取消該訂單?',
    cancelsuccess:'取消成功',
    cancelfailed:'取消失敗',
    requesterror:'預訂失敗，請稍候再試',
    uploaderror:'上傳失敗，請調整文件大小或更換文件',
    validateError: '卡號驗證失敗',
    missSession: '缺少支付信息',
    paymentSuccess: '支付成功',
    paymentFail: '支付失敗',
    paymentNotice: '當前系統升級中，若持有卡號以 626310 / 626311付款無法成功，請撥打禮賓服務熱線 852-2603-9512。不便之處，敬請諒解。',
    errorTime: '該時間段不可選擇'
}

export const form = {
    master: '是否為主卡人',
    yes: '是',
    no: '否',
    noValidate: '非主卡人不可預訂',
    searchcity: '搜索城市',
    searchkey: '請輸入關鍵詞',
    roomnumber: '房間數',
    peopleNumber: '預訂人數',
    checkin: '入住日期',
    checkout: '離店日期',
    cost: '總計',
    price: '房價明細',
    other: '其他',
    tax: '稅款及服務費',
    information: '聯絡信息',
    name: '姓名',
    gender: '尊稱',
    male: '先生',
    female: '女士',
    firstname: '名',
    lastname: '姓',
    contactmobile: '聯繫電話',
    areacode: '區號',
    mobile: '手機號',
    contactemail: '聯繫郵箱',
    emailaddress: '郵箱地址',
    contacttime: '期望聯繫時間',
    dateperiod: '聯繫日期段',
    timeperiod: '聯繫時間段',
    timedetail: '客服人員將于您期望的時間聯繫以確認預訂信息',
    fqt: '常旅行計劃碼',
    fqttip: '請于入住酒店時確認',
    codenumber: '常旅行計劃碼',
    special: '特殊要求',
    specialtip: '請填寫特殊要求，最多200字',
    payment: '支付明細',
    paymentmethod: '支付方式',
    cardtype: '支付卡類型',
    cardnumber: '卡號',
    expiration: '有效期至',
    month: '月',
    year: '年',
    creditcard:'信用卡',
    success: '預訂成功',
    enquiresent: '您的意向已提交',
    successnotice: '您已成功提交，我們將儘快聯繫您',
    contactdetail: '如有關於已預訂服務的更新，我們將通過電子郵件、短信或電話聯繫您。',
    contactmethod: '期望聯繫方式',
    phonecall: '電話',
    email: '郵箱',
    anyday: '任意日期',
    weekday: '工作日',
    weekend: '週末',
    anytime: '任意時間',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    additional: '其他需求',
    additionaltip: '如有任何特殊要求或備註，請留言說明。',
    attendeenumber: '同行人數',
    attendee: '同行人',
    reservedate: '預訂時間',
    time: '送機的接載時間必須安排在航班起飛前至少 3 小時',
    // time: '當前最早可預訂日期為10月16日',
    call: '致電',
    isrequired:'不能為空',
    cardNumberTip:'請輸入16位卡號',
    upload: '上傳憑證',
    uploadtips:'連續前2個月内使用同一張合資格卡累計零售消費4,000港元（最多可上傳2張，支持jpg、png、pdf）',
    peopleunit: '人',
    departure: '出發地',
    departureInput: '請填寫出發地地址',
    airport:'請選擇機場',
    destination: '目的地',
    destinationInput: '請填寫目的地地址',
    flightNo: '航班號',
    flightNoInput: '請填寫航班號',
    carType: '請選擇車型',
    pickup:'接機服務資訊',
    dropoff: '送機服務資訊',
    clause: "凌晨 00:00 至 05:59 之間的接載服務需額外收費 HKD100。<br/>接機的免費等候時間為航班降落後 75 分鐘；送機接送則為預定接載時間後 15 分鐘。超時等候需額外收費。<br/>送機的接載時間必須安排在航班起飛前至少 3 小時。<br/>最多可容納4個標準尺寸的行李箱（22'' x 12'' x 30''）。",
    addFee: '額外收費',
    luggage: '行李數',
    luggageInput:'請填寫行李數'
}

export const order = {
    checkin: '入住',
    checkout: '退房',
    total: '共計',
    reservation: '下單日期',
    success: '預訂成功',
    cancel: '已取消',
    name: '姓名',
    phone: '手機號',
    email: '郵箱地址',
    useDate: '預訂日期',
    special: '其他需求',
    cancelTxt: '取消訂單',
    confirm:'確認取消訂單?',
    failed: '取消失敗',
    price: '訂單金額'
}

export const other = {
    hotcity: '熱門城市',
    address: '地址',
    summary: '介紹',
    details: '詳情',
    clause: '條款',
    service: '諮詢服務',
    reservation: '預訂查詢',
    terms: '條款&條件',
    termsdetail: '<p>1. 某些房型不適用於客房升等或特別優惠。</p><p>2. 房型如有變化酒店擁有最終解釋權。</p><p>3. 並不是所有參與酒店都提供客房內Wi-Fi禮遇。敬請致電客戶服務熱線瞭解更多詳情。</p><p>4. 酒店體驗禮遇根據酒店而不同，敬請致電客服熱線瞭解更多詳情。</p> ',
    domestic:'中國',
    searchKey: '請輸入餐廳名字',
    basePrice:'原價',
    activePrice: '活動價',
    tc: '服務條款及細則',
    time: '聯絡時間',
    timedetail: '每天24小時 | 週一至週日'
}

export const telephone = {
    China: '中國',
    Macao: '澳門',
    Japan: '日本',
    HongKong: '香港',
    Guam: '美國',
    Australia: '澳大利亞',
    France: '法國'
}

export const login = {
    phoneNumber: '請輸入手機號',
    code: '請輸入驗證碼',
    send: '發送驗證碼',
    login: '驗證登錄',
    errorPhoneNumber: '手機號有誤',
    failSend: '驗證碼發送失敗',
    emptyCode: '驗證碼不能為空',
    failVerify: '驗證失敗請稍候重試'
}


// WEBPACK FOOTER //
// ./src/language/tc.js